import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import type {
	GetWidgetInteractionResultsRequestParams,
	GetWidgetInteractionResultsResponse,
} from './types';

export const getWidgetInteractionResults = async ({
	widgetId,
	maxResultsCount = 6,
	isApp = false,
	interactionsBaseUrl,
}: GetWidgetInteractionResultsRequestParams): Promise<
	AxiosResponse<GetWidgetInteractionResultsResponse>
> => {
	const url = interactionsBaseUrl
		? `${interactionsBaseUrl}/${widgetId}/results`
		: `/cityzens/interactions/${widgetId}/results`;

	return api.get<GetWidgetInteractionResultsResponse>(url, {
		params: {
			maxResultsCount,
			isApp: Boolean(isApp),
		},
	});
};
